import axios from './AxiosConfig'
import config from './../config'
import store from './../stores'

import { accommodationsDataSuccess, accommodationsDataError } from './../actions'

const baseUrl = config.apiBaseUrl

const AccommodationsDataSources = {
    index: (successCallback, errorCallback) => {
        return axios.get(`${baseUrl}/accommodations_data`)
            .then(function(response) {
                store.dispatch(accommodationsDataSuccess(response.data, successCallback))
            })
            .catch(function(response){
                store.dispatch(accommodationsDataError(response, errorCallback))
            });
    }
};

export default AccommodationsDataSources



// WEBPACK FOOTER //
// ./src/sources/AccommodationsDataSource.js